import { BlockCodeMirrorInnerField, LanguageMode } from '../CodeMirror/CodeMirror';
import { type ConfigFieldProps } from '../types';

interface DynamicFieldExpressionValueProps extends ConfigFieldProps {
  fieldId: string;
}

export function DynamicFieldExpressionValue(props: DynamicFieldExpressionValueProps) {
  const { fieldId, fieldName } = props;
  return (
    <BlockCodeMirrorInnerField
      languageMode={LanguageMode.Expression}
      fieldId={fieldId}
      fieldName={`${fieldName}.expression`}
      minHeight="unset"
      basicSetup={{ foldGutter: false, lineNumbers: false }}
      label="Expression"
    />
  );
}
